<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Campaign: {{ campaign.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 800px">
    <h5 class="mb-0" i18n>General Information</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Name</div>
        <div>{{ campaign.name }}</div>
        <div *ngIf="campaignNameValidator" class="error" i18n>Invalid!</div>
        <div class="field-label mt-3" i18n>Category</div>
        <div>{{ (campaign.category | titlecase) || '-' }}</div>
        <div class="field-label mt-3" i18n>Description</div>
        <div>{{ campaign.description || '-' }}</div>
        <div class="field-label mt-3" i18n>Campaign App Type</div>
        <div>{{ campaign.app_type | titlecase }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Campaign Type</div>
          <nb-icon class="ml-2" icon="info-outline" [nbTooltip]="getTooltip(campaign.campaign_type)"></nb-icon>
        </div>
        <div>{{ (campaign.campaign_type | splitWordUppercase) || '-' }}</div>
        <div class="field-label mt-3" i18n>Content Payload Types</div>
        <div>
          <span *ngFor="let payloadRecordType of payloadRecordTypes; let last = last">
            {{ payloadRecordType | replaceunderscore | titlecase }}<span *ngIf="!last">, </span>
          </span>
          <div *ngIf="payloadRecordTypes.length === 0">-</div>
        </div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Status</div>
        <div>{{ statusLabel }}</div>
        <div class="field-label mt-3" i18n>Schedule</div>
        <div>{{ scheduleLabel }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Frequency</div>
          <nb-icon class="ml-2" icon="info-outline" nbTooltip="How often campaign runs." i18n-nbTooltip></nb-icon>
        </div>
        <div>{{ frequencyLabel }}</div>
        <div class="field-label mt-3 d-flex">
          <div i18n>Resend Buffer</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="The amount of time that must elapse before the user can receive the message again after first receiving it."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div>{{ campaign.frequency_days }} days</div>
      </div>
    </div>

    <h5 class="mb-0" i18n>Associations</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Insight</div>
        <div class="d-flex align-items-center">
          {{ campaign.trigger_id }}
          <button
            nbButton
            outline
            shape="round"
            size="small"
            status="info"
            class="ml-2"
            (click)="viewInsight(campaign.trigger_id)"
            nbTooltip="View Details"
            i18n-nbTooltip
          >
            <nb-icon icon="search-outline"></nb-icon>
          </button>
        </div>
        <div class="field-label mt-3" i18n>Content</div>
        <div class="d-flex align-items-center">
          {{ campaign.content_id }}
          <button
            nbButton
            outline
            shape="round"
            size="small"
            status="info"
            class="ml-2"
            (click)="viewContent(campaign.content_id)"
            nbTooltip="View Details"
            i18n-nbTooltip
          >
            <nb-icon icon="search-outline"></nb-icon>
          </button>
        </div>
        <div class="field-label mt-3" i18n>Surveys</div>
        <div class="d-flex align-items-center" *ngFor="let survey of selectedSurveys">
          {{ survey.id }}
          <button
            nbButton
            outline
            shape="round"
            size="small"
            status="info"
            class="ml-2"
            (click)="viewSurvey(survey)"
            nbTooltip="View Details"
            i18n-nbTooltip
          >
            <nb-icon icon="search-outline"></nb-icon>
          </button>
        </div>
        <div *ngIf="selectedSurveys?.length === 0">-</div>
      </div>
      <div class="col">
        <div class="field-label d-flex">
          <div i18n>Condition</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Conditional campaigns can send notifications based on whether the robot has or has not received notifications from other campaigns."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div class="field-label mt-2 d-flex" *ngIf="condition_all.length">
          <div i18n>ALL</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Robot has received notifications from ALL of these campaigns."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div class="d-flex align-items-center" *ngFor="let campaign of condition_all">
          {{ campaign.campaign_id }}
          <button
            nbButton
            outline
            shape="round"
            size="small"
            status="info"
            class="ml-2"
            (click)="viewCampaign(campaign.campaign_id)"
            nbTooltip="View Details"
            i18n-nbTooltip
          >
            <nb-icon icon="search-outline"></nb-icon>
          </button>
        </div>
        <div class="field-label mt-2 d-flex" *ngIf="condition_any.length">
          <div i18n>ANY</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Robot has received notifications from ANY of these campaigns."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div class="d-flex align-items-center" *ngFor="let campaign of condition_any">
          {{ campaign.campaign_id }}
          <button
            nbButton
            outline
            shape="round"
            size="small"
            status="info"
            class="ml-2"
            (click)="viewCampaign(campaign.campaign_id)"
            nbTooltip="View Details"
            i18n-nbTooltip
          >
            <nb-icon icon="search-outline"></nb-icon>
          </button>
        </div>
        <div class="field-label mt-2 d-flex" *ngIf="condition_not_all.length">
          <div i18n>NOT ALL</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Robot has NOT received notifications from ALL of these campaigns."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div class="d-flex align-items-center" *ngFor="let campaign of condition_not_all">
          {{ campaign.campaign_id }}
          <button
            nbButton
            outline
            shape="round"
            size="small"
            status="info"
            class="ml-2"
            (click)="viewCampaign(campaign.campaign_id)"
            nbTooltip="View Details"
            i18n-nbTooltip
          >
            <nb-icon icon="search-outline"></nb-icon>
          </button>
        </div>
        <div class="field-label mt-2 d-flex" *ngIf="condition_not_any.length">
          <div i18n>NOT ANY</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Robot has NOT received notifications from ANY of these campaigns."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div class="d-flex align-items-center" *ngFor="let campaign of condition_not_any">
          {{ campaign.campaign_id }}
          <button
            nbButton
            outline
            shape="round"
            size="small"
            status="info"
            class="ml-2"
            (click)="viewCampaign(campaign.campaign_id)"
            nbTooltip="View Details"
            i18n-nbTooltip
          >
            <nb-icon icon="search-outline"></nb-icon>
          </button>
        </div>
        <div
          *ngIf="
            condition_all.length === 0 &&
            condition_any.length === 0 &&
            condition_not_all.length === 0 &&
            condition_not_any.length === 0
          "
        >
          -
        </div>
        <div class="field-label mt-3 d-flex" *ngIf="show_condition">
          <div i18n>Time Frame</div>
          <nb-icon
            class="ml-2"
            icon="info-outline"
            nbTooltip="Time frame in which to evaluate the condition."
            i18n-nbTooltip
          ></nb-icon>
        </div>
        <div *ngIf="show_condition" i18n>{{ time_frame }} days</div>
      </div>
    </div>

    <h5 class="mb-0" i18n>Metadata</h5>
    <hr />

    <div class="row mb-5">
      <div class="col">
        <div class="field-label" i18n>Last Run Status</div>
        <div>{{ campaign.status | titlecase }}</div>
        <div class="field-label mt-3" i18n>Last Run Time</div>
        <div>{{ (campaign.last_run_time | customValueHandling: 'last_run_time') || '-' }}</div>
        <div class="field-label mt-3" i18n>Next Run Time</div>
        <div>{{ (campaign.next_run_time | customValueHandling: 'next_run_time') || '-' }}</div>
        <div class="field-label mt-3" i18n>Total Executions</div>
        <div>{{ campaign.executions | customValueHandling: 'executions' }}</div>
        <div class="field-label mt-3" i18n>Average Execution Time</div>
        <div>{{ averageExecutionDuration | formatTime }}</div>
        <div class="field-label mt-3" i18n>Total Deliveries</div>
        <div>{{ campaign.total_results | customValueHandling: 'total_results' }}</div>
      </div>
      <div class="col">
        <div class="field-label" i18n>Created By</div>
        <div>{{ campaign.created_by || '-' }}</div>
        <div class="field-label mt-3" i18n>Created On</div>
        <div>{{ (campaign.created_dttm | customValueHandling: 'created_dttm') || '-' }}</div>
        <div class="field-label mt-3" i18n>Last Updated By</div>
        <div>{{ campaign.last_updated_by || '-' }}</div>
        <div class="field-label mt-3" i18n>Last Updated On</div>
        <div>{{ (campaign.last_updated_dttm | customValueHandling: 'last_updated_dttm') || '-' }}</div>
        <div class="field-label mt-3" i18n>Promoted</div>
        <div>{{ promotedLabel }}</div>
        <div *ngIf="campaign.promoted" class="field-label mt-3" i18n>Promoted By</div>
        <div *ngIf="campaign.promoted">{{ campaign.promoted_by || '-' }}</div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button *ngIf="displayManagementButtons" nbButton class="ml-3" status="success" (click)="runOnce()" i18n>
        Run Once
      </button>
      <button
        *ngIf="displayPromotionButton"
        nbButton
        [disabled]="!disablePromotionButton"
        class="ml-3"
        status="success"
        (click)="promoteCampaign()"
        i18n
      >
        Promote
      </button>
      <button
        *ngIf="displayManagementButtons"
        nbButton
        class="ml-3"
        status="info"
        (click)="viewStats(campaign.id)"
        i18n
      >
        View Stats
      </button>
      <button
        *ngIf="displayManagementButtons && campaign.enabled === true"
        nbButton
        class="ml-3"
        status="danger"
        (click)="deactivateCampaign()"
        i18n
      >
        Deactivate
      </button>
      <button
        *ngIf="displayManagementButtons && campaign.enabled === false"
        nbButton
        class="ml-3"
        status="success"
        (click)="activateCampaign()"
        i18n
      >
        Activate
      </button>
    </div>
  </nb-card-footer>
</nb-card>
